var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DeviceAppBarPage",
    { attrs: { title: _vm.pageTitle } },
    [
      _c(
        "KPageContainer",
        { staticClass: "device-container" },
        [
          _c("div", { staticClass: "description" }, [
            _c("h1", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.coreString("devicePermissionsLabel")) +
                  "\n      "
              ),
            ]),
            _c("p", [_vm._v(_vm._s(_vm.$tr("devicePermissionsDescription")))]),
          ]),
          _c("PaginatedListContainer", {
            attrs: {
              dataLoading: _vm.loadingFacilityUsers,
              items: _vm.usersFilteredByDropdown,
              filterPlaceholder: _vm.$tr("searchPlaceholder"),
            },
            scopedSlots: _vm._u([
              {
                key: "otherFilter",
                fn: function () {
                  return [
                    _c("KSelect", {
                      staticClass: "type-filter",
                      attrs: {
                        label: _vm.$tr("permissionsLabel"),
                        options: _vm.permissionsOptions,
                        inline: true,
                      },
                      model: {
                        value: _vm.permissionsFilter,
                        callback: function ($$v) {
                          _vm.permissionsFilter = $$v
                        },
                        expression: "permissionsFilter",
                      },
                    }),
                    _c("KSelect", {
                      staticClass: "type-filter",
                      attrs: {
                        label: _vm.coreString("userTypeLabel"),
                        options: _vm.userTypeOptions,
                        inline: true,
                      },
                      model: {
                        value: _vm.userTypeFilter,
                        callback: function ($$v) {
                          _vm.userTypeFilter = $$v
                        },
                        expression: "userTypeFilter",
                      },
                    }),
                    _vm.hasMultipleFacilities
                      ? _c("KSelect", {
                          staticClass: "type-filter",
                          attrs: {
                            label: _vm.coreString("facilityLabel"),
                            options: _vm.facilityOptions,
                            inline: true,
                          },
                          model: {
                            value: _vm.facilityFilter,
                            callback: function ($$v) {
                              _vm.facilityFilter = $$v
                            },
                            expression: "facilityFilter",
                          },
                        })
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (ref) {
                  var items = ref.items
                  var filterInput = ref.filterInput
                  return [
                    _c("UserGrid", {
                      attrs: {
                        dataLoading: _vm.loadingFacilityUsers,
                        searchFilter: _vm.searchFilterText,
                        facilityUsers: items,
                        userPermissions: _vm.userPermissions,
                        filterText: filterInput,
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }